<span class="ui-checkbox">
  <input type="checkbox" [attr.id]="controlId()" [ngModel]="value()" (ngModelChange)="onModelChange($event)" />
  <label [attr.for]="controlId()">
    <ng-content />
  </label>
  <ui-icon class="icon-check" iconName="check" size="xs" />
</span>
